module.exports = __webpack_public_path__ + "afad0315399f208de0203c3a308c0629.svg";